import { render, staticRenderFns } from "./ResetSenha.vue?vue&type=template&id=5451d9df&scoped=true&"
import script from "./ResetSenha.vue?vue&type=script&lang=js&"
export * from "./ResetSenha.vue?vue&type=script&lang=js&"
import style0 from "./ResetSenha.vue?vue&type=style&index=0&id=5451d9df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5451d9df",
  null
  
)

export default component.exports